import { useState } from "react";
import { ToastContainer } from "react-toastify";

import AdminsList from "./AdminsList";
import InviteAdmins from "./InviteAdmins";

export default function AdminsPage() {
  const [refreshAdmins, setRefreshAdmins] = useState(false);

  const triggerRefresh = () => {
    setRefreshAdmins((prev) => !prev);
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="admins-page-wrapper">
        <div className="row-essy">
          <div className="col-essy-lg-6 col-essy-md-6">
            <AdminsList refreshTrigger={refreshAdmins} />
          </div>
          <div className="col-essy-lg-6 col-essy-md-6">
            <InviteAdmins onInviteSuccess={triggerRefresh} />
          </div>
        </div>
      </div>
    </>
  );
}
